import { createServerFn } from "@tanstack/react-start";
import type { TenantContext } from "./types";

/**
 * Public, read-only tenant context for the current request.
 *
 * The tenant is resolved SERVER-SIDE from the request Host header only. The
 * function takes no input, so a browser can never select a different tenant.
 * Only non-sensitive presentation metadata is returned (id, code, name,
 * status); no platform-level tenant list is exposed.
 */
export const getTenantContext = createServerFn({ method: "GET" }).handler(
  async (): Promise<TenantContext | null> => {
    const { resolveTenantContextForRequest } = await import("./resolve.server");
    return resolveTenantContextForRequest();
  },
);
